import * as Sentry from "@sentry/react";
import { SupabaseClient } from "@supabase/supabase-js";
import { supabaseIntegration } from "@supabase/sentry-js-integration";

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

function initSentry() {
  if (!SENTRY_DSN || Sentry.getClient()) {
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment:
      import.meta.env.VITE_APP_ENVIRONMENT?.trim() || import.meta.env.MODE,
    ignoreErrors: [
      /404 Error/i,
      /code\s+404/i,
      /status\s+404/i,
      /not found/i,
      "Network Error",
    ],
    integrations: [
      Sentry.captureConsoleIntegration({ levels: ["error"] }),
      supabaseIntegration(SupabaseClient, Sentry, {
        tracing: false,
        breadcrumbs: false,
        errors: true,
      }),
    ]
  });
}

initSentry();
